import React, { useState } from "react";
import "./TAPAY.css";
import { FaWallet, FaShieldAlt,FaMobileAlt,FaClock, FaArrowRight,
FaEnvelopeOpenText,
FaHeadset, FaUser, FaCreditCard, FaClipboardList, FaCogs, FaUsers, FaStore, FaMoneyBillWave, FaHandshake, FaShieldVirus, FaFileInvoice, FaExchangeAlt, FaRedoAlt, FaPiggyBank, FaTachometerAlt, FaLock } from "react-icons/fa";
import { FaCommentDots, FaChartLine, FaPalette, FaProjectDiagram } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
const TAPAY = () => {
  // const [hoverIndex, setHoverIndex] = useState(null);

const tapayfeatures = [
  {
    title: "Seamless Payment Experience",
    description:
      "Link Payments via SMS & Email with built-in PDF invoicing through multiple channels.",
    iconColor: "#2563EB",
    icon: <FaCommentDots  />,
  },
  {
    title: "Intelligent Reporting",
    description:
      "Real-time, customizable MIS reports with smart business insights and analytics.",
    iconColor: "#10B981",
    icon: <FaChartLine  />,
  },
  {
    title: "Chargeback Simplified",
    description:
      "Integrated chargeback management with document manager for efficient dispute resolution.",
    iconColor: "#8B5CF6",
    icon: <FaShieldAlt  />,
  },
  {
    title: "Fully White-Labelled",
    description:
      "Complete platform customization to match your brand identity and business image.",
    iconColor: "#F97316",
    icon: <FaPalette  />,
  },
  {
    title: "Smart Routing Engine",
    description:
      "Sophisticated router with multiple gateways, merchant-bank routing, and BIN-based intelligence.",
    iconColor: "#6366F1",
    icon: <FaProjectDiagram />,
  },
];

  const features = [
  { icon: <FaCogs />, label: 'Easy Integration', bg: '#00b884' },
  { icon: <FaShieldAlt />, label: 'Buyer Protection', bg: '#5a55e4' },
  { icon: <FaCreditCard />, label: 'Authorization Holds', bg: '#ffba08' },
  { icon: <FaClipboardList />, label: 'Split Settlements', bg: '#00b884' },
  { icon: <FaRedoAlt />, label: 'Quick Refunds', bg: '#b5179e' },
  { icon: <FaFileInvoice />, label: 'Online Invoicing', bg: '#ef476f' },
  { icon: <FaExchangeAlt />, label: 'Payment Chalans', bg: '#118ab2' },
  { icon: <FaShieldVirus />, label: 'Recurring Billing', bg: '#8338ec' },
  { icon: <FaPiggyBank />, label: 'White Label Wallet', bg: '#06d6a0' },
  { icon: <FaMoneyBillWave />, label: 'Pre-paid TDR', bg: '#f3722c' },
  { icon: <FaTachometerAlt />, label: 'Rich Dashboard', bg: '#ff006e' },
  { icon: <FaLock />, label: 'PCI DSS Certified', bg: '#06d6a0' },
];
 const [hoverIndex, setHoverIndex] = useState(null);
  return (
    <div className="landing-container">
 <section className="payment-section">
<div className="payment-content slide-in-left">
  <h2 style={{ fontSize: "48px", fontWeight: "750" }}>
    Get Paid{" "}
    <span
      style={{
        background: "linear-gradient(135deg, #0b84ff, #00b884)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        display: "inline-block",
      }}
    > 
      Instantly.
    </span>
    <br />
    Securely. Anytime.
  </h2>

  <p>
    A sophisticated Online Payments Platform designed and built for tomorrow. Receive Payments. Anytime, Anywhere with our cutting-edge fintech solutions.
  </p>

  <div className="payment-features">
    <span><FaShieldAlt className="check-icon" /> PCI</span>
    <span><FaMobileAlt className="check-icon" /> Mobile Optimized</span>
    <span><FaCreditCard className="check-icon" /> Multiple Payment Options</span>
  </div>
</div>


  <div className="payment-image">
    <img
      src="/assets/images/image (14).png"
      alt="Payment Illustration"
    className="zoom-in-image"
    />
  </div>
</section>



      {/* Offerings Section */}
   <section style={{ padding: "60px 20px", fontFamily: "Segoe UI, sans-serif", backgroundColor: "#fff" }}>
      {/* Heading */}
      <h2 style={{ textAlign: "center", fontSize: "40px", fontWeight: "700", marginBottom: "30px" }}>
        Our Core Services
        <div
          style={{
            width: "80px",
            height: "4px",
            background: "linear-gradient(to right, #00c292, #3f51b5)",
            margin: "10px auto 0",
            borderRadius: "2px",
          }}
        ></div>
      </h2>

      {/* Grid Container */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "30px",
          flexWrap: "wrap",
        }}
      >
        {/* Card 1 - Payment Gateway */}
        <div
          style={{
            backgroundColor: "#f0f9f8",
            borderRadius: "14px",
            padding: "30px",
            width: "460px",
            // boxShadow: "0 10px 30px rgba(0,0,0,0.06)", 
            transition: "transform 0.3s ease",
          }}
        >
          <div
            style={{
              backgroundColor: "#00c292",
              padding: "10px",
              borderRadius: "12px",
              display: "inline-block",
              marginBottom: "20px",
            }}
          >
            <FaWallet size={30} color="#fff" />
          </div>
          <h3 style={{ fontSize: "28px", fontWeight: "600", marginBottom: "10px" }}>
            Payment Gateway
          </h3>
          <p style={{ fontSize: "18px", color: "#555", lineHeight: "1.6", marginBottom: "20px" }}>
            Integrate your website or mobile app with our state of the art Payment Gateway.
            For those not on tech savvy, our easy-to-integrate TA Pay Lite comes in handy.
          </p>
          <a
            href="https://pg.tapay.in"
            style={{
              textDecoration: "none",
              color: "#00c292",
              fontWeight: "500",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              border: "1px solid #00c292",
              padding: "8px 16px",
              borderRadius: "6px",
              fontSize: "18px",
              transition: "all 0.2s ease",
            }}
          >
            Learn More <span style={{ fontSize: "16px" }}>→</span>
          </a>
        </div>

        {/* Card 2 - SaaS Offerings */}
        <div
          style={{
            backgroundColor: "#f4f6ff",
            borderRadius: "14px",
            padding: "30px",
            width: "460px",
            // boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
            transition: "transform 0.3s ease",
          }}
        >
          <div
            style={{
              backgroundColor: "#3f51b5",
              padding: "10px",
              borderRadius: "12px",
              display: "inline-block",
              marginBottom: "20px",
            }}
          >
            <FaMobileAlt size={30} color="#fff" />
          </div>
          <h3 style={{ fontSize: "28px", fontWeight: "600", marginBottom: "10px" }}>
            SaaS Offerings
          </h3>
          <p style={{ fontSize: "18px", color: "#555", lineHeight: "1.6", marginBottom: "20px" }}>
            Our SaaS based Payment collection software helps you receive and track payments
            in real-time. Customers have a range of payment options to choose from.
          </p>
          <a
            href="https://pg.tapay.in/invoice.html"
            style={{
              textDecoration: "none",
              color: "#3f51b5",
              fontWeight: "500",
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              border: "1px solid #3f51b5",
              padding: "8px 16px",
              borderRadius: "6px",
              fontSize: "18px",
              transition: "all 0.2s ease",
            }}
          >
            Learn More <span style={{ fontSize: "18px" }}>→</span>
          </a>
        </div>
      </div>
    </section>


       {/* Stats Section */}
<div className="stats-container">
      <div className="stats-grid">
        <div className="stat-item">
          <div className="icon-wrapper" style={{ backgroundColor: "#00b884" }}>
            <FaUsers className="stat-icon" />
          </div>
          <div className="stat-content">
            <h3>40,266+</h3>
            <p>Happy Clients</p>
            <small>They can’t be wrong</small>
          </div>
        </div>

        <div className="stat-item">
          <div className="icon-wrapper" style={{ backgroundColor: "#5a55e4" }}>
            <FaStore className="stat-icon" />
          </div>
          <div className="stat-content">
            <h3>1,208+</h3>
            <p>Merchants</p>
            <small>Satisfaction guaranteed</small>
          </div>
        </div>

        <div className="stat-item">
          <div className="icon-wrapper" style={{ backgroundColor: "#ffba08" }}>
            <FaMoneyBillWave className="stat-icon" />
          </div>
          <div className="stat-content">
            <h3>80+</h3>
            <p>Payment Options</p>
            <small>Available at your fingertips</small>
          </div>
        </div>

        <div className="stat-item">
          <div className="icon-wrapper" style={{ backgroundColor: "#00b884" }}>
            <FaHandshake className="stat-icon" />
          </div>
          <div className="stat-content">
            <h3>40+</h3>
            <p>Channel Partners</p>
            <small>Many more to come</small>
          </div>
        </div>
      </div>
    </div>
      {/* </section> */}


  <section className="container features">
    <h2 className="features-heading" style={{ marginTop: "30px", textAlign: "center",fontSize:"38px",fontWeight:"700" }}>
  Key Features
</h2>

      <div className="underline"></div>

      <div className="features-grid">
        {features.map((feature, index) => (
          <div className="feature-card" key={index}>
            <div
              className="icon-wrapper"
              style={{ backgroundColor: feature.bg }}
            >
              {React.cloneElement(feature.icon, { color: '#fff', size: 28 })}
            </div>
            <p className="feature-label">{feature.label}</p>
          </div>
        ))}
      </div>
    </section>













<section
  style={{
    padding: "60px 20px",
  }}
>
  <h2
    style={{
      textAlign: "center",
      fontSize: "38px",
      fontWeight: "700",
      marginBottom: "16px",
      color: "#111827",
    }}
  >
    What Differentiates Us
from the Rest?
  </h2>

  <div
    style={{
      height: "4px",
      width: "80px",
      backgroundColor: "#0F766E",
      margin: "0 auto 40px auto",
      borderRadius: "4px",
    }}
  ></div>

  <div
    style={{
      maxWidth: "1280px",
      margin: "0 auto",
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))",
      gap: "32px",
    }}
  >
    {tapayfeatures.map((feature, index) => {
      const isHovered = hoverIndex === index;
      // const isOrangeCard = index === 3;

      // const cardBorderColor = isOrangeCard ? "#F97316" : "#E5E7EB";

      return (
        <div
          key={index}
          style={{
            border: `2px solid #dcdcdcff`,
            borderRadius: "16px",
            padding: "32px",
            // backgroundColor: isOrangeCard && isHovered ? "#FFF7ED" : "#ffffff",
            boxShadow:
             
                "0 6px 20px rgba(0, 0, 0, 0.08)",
                
            transition: "all 0.3s ease",
            cursor: "pointer",
          }}
          onMouseEnter={() => setHoverIndex(index)}
          onMouseLeave={() => setHoverIndex(null)}
        >
          <div
            style={{
              width: "48px",
              height: "48px",
              backgroundColor: feature.iconColor,
              color: "#ffffff",
              borderRadius: "12px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "24px",
              marginBottom: "24px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.05)",
              border: `2px solid }`, // This line adds the icon border
            }}
          >
            {feature.icon}
          </div>
          <h3
            style={{
              fontSize: "20px",
              fontWeight: "700",
              color: "#111827",
              marginBottom: "12px",
            }}
          >
            {feature.title}
          </h3>
          <p
            style={{
              fontSize: "15px",
              color: "#4B5563",
              lineHeight: "1.6",
              marginBottom: "20px",
            }}
          >
            {feature.description}
          </p>
          {/* <button
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              backgroundColor:
                  isHovered ? "#ffffffff" : "#ffffff",
              color:  isHovered ? "#0F766E" : "#0F766E",
              border: "1px solid #0f766eff",
              borderRadius: "8px",
              padding: "10px 20px",
              fontSize: "14px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.3s ease",
              outline: "none",
            }}
          >
            Learn More{" "}
            <span
              style={{
                fontSize: "16px",
                display: "inline-block",
                transform: "translateY(1px)",
              }}
            >
              →
            </span>
          </button> */}
        </div>
      );
    })}
  </div>
</section>



      {/* Business Transformation */}
     <section className="business-transform">
      <h2>
        Transform your Business. Switch to new forms of Payment <br/> collection.
      </h2>
      <p>It's hassle-free, safe and secure</p>

      <div className="transform-grid">
        <div className="transform-card" style={{ backgroundColor: '#e6fbf8' }}>
          <div className="icon-wrapper" style={{ backgroundColor: '#00b884' }}>
            <FaClock className="iconfiled" color="white" />
          </div>
          <h3>Faster Settlements</h3>
          <p>
            Our sophisticated settlements algorithm will ensure that you receive
            funds at the earliest possible time.
          </p>
        </div>

        <div className="transform-card" style={{ backgroundColor: '#f0f3ff' }}>
          <div className="icon-wrapper" style={{ backgroundColor: '#5a55e4' }}>
            <FaUser className="iconfiled" color="white" />
          </div>
          <h3>Quick Onboarding</h3>
          <p>
            Onboarding is plain and simple. Upload your KYC, Get approval. Start
            collecting Payments.
          </p>
        </div>

        <div className="transform-card" style={{ backgroundColor: '#fff7e7' }}>
          <div className="icon-wrapper" style={{ backgroundColor: '#ffba08' }}>
            <FaShieldAlt className="iconfiled" color="white" />
          </div>
          <h3>Zero Risk</h3>
          <p>
            Our state of the art infrastructure and fraud prevention systems are
            designed to protect you.
          </p>
        </div>
      </div>

      
    </section>
{/* ================= PG DOCUMENTATION SECTION ================= */}
{/* ================= TERMS & CONDITIONS SECTION ================= */}
{/* <section className="terms-section">
  <div className="terms-container">

    <h3 className="terms-heading">
  Policies & Agreements
    </h3>

    <div className="terms-list">

      <a href="/docs/terms-english" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">
            📄
          </div>
          <span>Terms & Conditions – English</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/docs/terms-hindi" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">
            📄
          </div>
          <span>Terms & Conditions – Hindi</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/docs/terms-kannada" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">
            📄
          </div>
          <span>Terms & Conditions – Kannada</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

      <a href="/docs/csr-agreement" className="terms-item">
        <div className="terms-left">
          <div className="terms-icon">
            📄
          </div>
          <span>Terms of Reference of CSR Program Tripartite Agreement</span>
        </div>
        <div className="terms-arrow">›</div>
      </a>

    </div>

  </div>
</section> */}
{/* PG Support Section */}
{/* Modern PG Support Section */}
<section className="ta-support-section">
      <div className="ta-support-container ">
        
        {/* Header Area */}
        <div className="ta-support-header">
          <span className="ta-support-badge">Payment Gateway Help Center</span>
          <h3><b>Payment Gateway Support</b></h3>
          <p className="ta-support-subtext">
            Need help with transactions, settlements, refunds, or integration? 
            Our dedicated technical support team is available 24/7.
          </p>
        </div>

        {/* Support Cards Grid */}
        <div className="ta-support-grid">
          
          {/* Card 1: Phone (Click to Call) */}
          <div className="ta-support-card">
            <div className="ta-card-icon phone-icon">
              <FaPhoneAlt />
            </div>
            <div className="ta-card-content">
              <h3>Nodal Officer</h3>
              <p>+91 8919056119</p>
              <small>For urgent transaction issues</small>
            </div>
            <div className="ta-card-arrow">
              <FaArrowRight />
            </div>
          </div>

          {/* Card 2: Email (Click to Email) */}
          <div className="ta-support-card">
            <div className="ta-card-icon email-icon">
              <FaEnvelopeOpenText />
            </div>
            <div className="ta-card-content">
              <h3>Nodal Officer Email</h3>
              <p>kirankumar.p@taipl.in</p>
              <small>Response within 2–4 hours</small>
            </div>
            <div className="ta-card-arrow">
              <FaArrowRight />
            </div>
          </div>

          {/* Card 3: Ticket (Primary Action) */}
          <a href="https://udir.transactionanalysts.com/customergrievance" target="_blank" rel="noopener noreferrer" className="ta-support-card ta-card-primary">
            <div className="ta-card-icon ticket-icon">
              <FaHeadset />
            </div>
            <div className="ta-card-content">
              <h3>Raise a Ticket</h3>
              <p>TAPAY Support Portal</p>
              <small>Track technical queries 24/7</small>
            </div>
            <div className="ta-card-arrow">
              <FaArrowRight />
            </div>
          </a>

        </div>
      </div>
    </section>
    </div>
  );
};

export default TAPAY;
